import firebase from 'firebase/app';
import { Creator } from './Creator';
import { DbDoc } from './FbDoc';
import { PriceField } from './PriceField';

export enum PriceFieldSuggestionResolutionStatus {
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
}

export type PriceFieldSuggestionResolution = {
    id: string
    resolution: {
        resolvedAt: firebase.firestore.Timestamp
        resolvedBy: Creator
        status: PriceFieldSuggestionResolutionStatus
    }
    suggestion: {
        priceField: DbDoc<PriceField>
    }
}
